export default {
    path : "enterprise-report",
    name : "enterprise-report",
    meta : {
        title : "企业报表"
    },
    component: () => import('@/components/router/Router'),

    redirect: {
        name : "enterprise-report-waitreview"
    },
    children:[
        {
            path: '',
            name: '',
            meta: {
                title: ''
            },
            redirect: {
                name : "enterprise-report-waitreview"
            },
            component: () => import('@/pages/enterprise/report/Index'),
            children: [
                {
                    path: 'waitreview',
                    name: 'enterprise-report-waitreview',
                    meta: {
                        title: '企业报表-待审核'
                    },
                    component: () => import('@/pages/enterprise/report/business/ReportList'),
                },
                {
                    path: 'reviewed',
                    name: 'enterprise-report-reviewed',
                    meta: {
                        title: '企业报表-已审核'
                    },
                    component: () => import('@/pages/enterprise/report/business/ReportList'),
                },
                {
                    path: 'allreview',
                    name: 'enterprise-report-allreview',
                    meta: {
                        title: '企业报表-全部审核'
                    },
                    component: () => import('@/pages/enterprise/report/business/ReportList'),
                },
                {
                    path: 'allreport',
                    name: 'enterprise-report-allreport',
                    meta: {
                        title: '企业报表-全部报表'
                    },
                    component: () => import('@/pages/enterprise/report/business/ReportList'),
                }
            ]
        },
        {
            path: 'enterprise-report-detail',
            name: 'enterprise-report-detail',
            meta: {
                title: '企业详细信息'
            },
            component: () => import('@/pages/enterprise/report/Detail'),
        }
    ]

}



// WEBPACK FOOTER //
// ./src/router/enterprise/report_enterprise/index.js